import { Navigate, useLocation } from "react-router-dom";

import {
  getStoredUser,
  isAuthenticated,
  SITE,
} from "../../utils/auth";

function ProtectedAdminRoute({ children }) {
  const location = useLocation();
  const user = getStoredUser();

  const hasAccess =
    isAuthenticated() &&
    user &&
    (
      user.isSuperuser ||
      user.sugalumpAccess ||
      user.site === SITE ||
      user.actingSite === SITE
    );

  if (!hasAccess) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
}

export default ProtectedAdminRoute;